<template>
  <div class="page-tabs">
    <router-link class="page-tab" to="/iabf/admin/deadlines">Deadlines &amp; access</router-link>
    <router-link class="page-tab" to="/iabf/admin/hold-log">Hold log</router-link>
  </div>
</template>

<script>
export default {
  name: 'DeadlinesHoldLogTabs'
}
</script>

<style scoped>
.page-tabs {
  display: flex;
  gap: 6px;
  margin: 0 0 20px;
}
.page-tab {
  display: inline-block;
  padding: 7px 14px;
  border-radius: 999px;
  border: 1px solid #e3e0e8;
  background: #fff;
  color: #5c5a63;
  text-decoration: none;
  font-size: 14px;
}
.page-tab:hover {
  background: #f6f4f1;
  color: #1c1b1f;
}
.page-tab.router-link-exact-active {
  background: #388b9d;
  border-color: #388b9d;
  color: #fff;
}
</style>
